import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { SearchableSelect } from '../ui/searchable-select';
import { UserPlus } from '@phosphor-icons/react';

export const AgencyFileBulkAssignDialog = ({
  bulkAssignOpen, setBulkAssignOpen,
  selectedIds, selectedFilesInfo, staffList,
  bulkStaffId, setBulkStaffId,
  bulkInstruction, setBulkInstruction,
  bulkAssigning, handleBulkAssign,
}) => (
  <Dialog open={bulkAssignOpen} onOpenChange={(o) => { if (!o) setBulkAssignOpen(false); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <UserPlus size={20} className="text-[#002FA7]" /> Bulk Assign — {selectedIds.size} Files
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm space-y-1.5" data-testid="bulk-assign-summary">
          <p className="font-medium text-blue-800">{selectedIds.size} files selected</p>
          <div className="flex flex-wrap gap-1.5">
            {selectedFilesInfo.files.slice(0, 8).map(f => (
              <span key={f.id} className="text-xs bg-white border border-blue-200 text-blue-700 px-2 py-0.5 rounded">
                {f.agency_name} ({f.entry_count})
              </span>
            ))}
            {selectedIds.size > 8 && <span className="text-xs text-blue-500">+{selectedIds.size - 8} more</span>}
          </div>
          <p className="text-xs text-blue-600">
            Total entries: {selectedFilesInfo.totalEntries}
          </p>
        </div>

        <div>
          <Label>Assign to Staff *</Label>
          <SearchableSelect
            options={staffList.map(s => ({ value: s.id, label: s.name, sublabel: s.email }))}
            value={bulkStaffId}
            onValueChange={setBulkStaffId}
            placeholder="Staff choose karo..."
            data-testid="bulk-assign-staff-select"
          />
        </div>
        <div>
          <Label>Instruction (Optional)</Label>
          <Input value={bulkInstruction} onChange={e => setBulkInstruction(e.target.value)}
            placeholder="e.g. Sabko aaj complete karna hai" data-testid="bulk-assign-instruction" />
        </div>
        <Button onClick={handleBulkAssign} disabled={bulkAssigning || !bulkStaffId}
          className="w-full bg-[#002FA7] hover:bg-[#002590]" data-testid="confirm-bulk-assign-btn">
          <UserPlus size={16} className="mr-2" />
          {bulkAssigning ? 'Assigning...' : `Assign ${selectedIds.size} Files`}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
